import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainCancelsCardLossReporting(card) {
  return maintainRequest({
    url: `/user/maintenanceMan/card/cancelsCardLossReporting/${card}`,
    method: "post",
  });
}
